import { render, staticRenderFns } from "./AdminRegistered.vue?vue&type=template&id=2ddaa121"
import script from "./AdminRegistered.vue?vue&type=script&lang=js"
export * from "./AdminRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports